import { render } from "./HandsGame.vue?vue&type=template&id=7bcf0400&scoped=true"
import script from "./HandsGame.vue?vue&type=script&lang=js"
export * from "./HandsGame.vue?vue&type=script&lang=js"

import "./HandsGame.vue?vue&type=style&index=0&id=7bcf0400&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bcf0400"]])

export default __exports__